export const Capitalize = (string) => {
    if (!string) return;
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const CamelCaseToTextCase = (text) => {
    const result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
};
